// extracted by mini-css-extract-plugin
export default {"row":"style_row__BmIeO","name":"style_name__aQZbu","formAvatarIcon":"style_formAvatarIcon__-qNHT","flexCol":"style_flexCol__Z0Bx-","formName":"style_formName__cx0uA"};